<template>
  <div>
    <router-view :config="config"></router-view>
  </div>
</template>

<script>

export default {
  props: {
    config: Object,
  },
};
</script>
